import React from "react";
import { CompanyAccountingInformation } from "../../../../forms/form-components/company-accounting-information.component";

export const RechnungswesenPage: React.FC = () => {
	return (
		<div className="p-6">
			<div className="max-w-6xl">
				<h1 className="text-2xl font-semibold text-gray-900 mb-6">Rechnungswesen</h1>
				<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
					<CompanyAccountingInformation />
				</div>
			</div>
		</div>
	);
};